import React, { Component } from "react";
import { Accessor, LocaleX, ZTime } from "IZOX/STATIC";
import PropsType from "prop-types";
import { XText, HStack } from "IZOX/_X";
import { observer } from "mobx-react";

/**
 * @augments {Component<Props, State>}
 */
class RefreshTimeCount extends Component {

  static propTypes = {
    onMounted: PropsType.func,
    refreshRate: PropsType.number
  }

  static defaultProps = {
    onMounted: null,
    refreshRate: 1000
  }

  constructor(){
    super();
    this.state = {
      lastUpdated: null,
      nextUpdated: null
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.Refresh();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(RefreshTimeCount.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  Refresh = () => {
    let {refreshRate} = this.props;
    this.setState({
      now: ZTime.Now()
    }, () => {
      if(this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.Refresh();
      }, refreshRate);
    });
  }

  _setNowAndNext = (nextUpdate, unit) => {
    let now = ZTime.Now();
    let next = ZTime.Add(now, nextUpdate, unit);
    this.setState({
      lastUpdated: now,
      nextUpdated: next
    });
  }

  _setLastUpdated = (date = ZTime.Now()) => {
    this.setState({
      lastUpdated: date
    });
  }

  _setNextUpdated = (nextUpdate, unit) => {
    let now = ZTime.Now();
    let next = ZTime.Add(now, nextUpdate, unit);
    this.setState({
      nextUpdated: next
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), () => {
      this.props.onMounted?.({
        SetNowAndNext: this._setNowAndNext,
        SetLastUpdated: this._setLastUpdated,
        SetNextUpdated: this._setNextUpdated,
      });
      callback?.();
    });
  }

  render(){
    let {lastUpdated, nextUpdated, now} = this.state;
    if(!lastUpdated && !nextUpdated) return <div/>;
    let _diff = nextUpdated ? ZTime.Difference(now, nextUpdated, "seconds", true) : 0;
    return (
      <HStack width={"fit-content"} 
        style={{
          paddingLeft: 15, 
          paddingRight: 15,
        }} spacing={10}>
        <HStack width={"auto"} spacing={10}>
          <XText>
            {LocaleX.Parse({
              EN: "Last Updated: ",
              TC: "上次更新時間: "
            })}
          </XText>
          <XText style={{fontWeight: "bold"}}>
            {ZTime.Locale(lastUpdated, "LLL:ss")}
          </XText>
        </HStack>
        <HStack width={"auto"} spacing={10}>
          <XText>
            {LocaleX.Parse({
              EN: "Up Next: ",
              TC: "下次更新: "
            })}
          </XText>
          <XText style={{fontWeight: "bold", width: 30}}>
            {`${_diff} s`}
          </XText>
        </HStack>
      </HStack>
    );
  }

}

export default observer(RefreshTimeCount);
